import { useState, useEffect } from "react";
import { Separator } from "../../../../../components/common/CustomBootstrap";
import { useHistory, useParams } from "react-router-dom";
import LanguagesList from "./languages";
import SoftSkills from "./softskills";
import Skills from "./skills";
import Certification from "./certification";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

import { Row, Button, FormGroup, CardBody, Card } from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";

import { JobService } from "../../../../../services/JobService";

const ReqSkills = (props) => {
  var { id } = useParams();
  const history = useHistory();
  const [jobStatus, setJobStatus] = useState("");

  const [jobDetails, setJobDetails] = useState();

  let count = 0;

  useEffect(() => {
    if (id !== "") {
      getJobDetails(id);
 
    }
  }, [count]);

  const getJobDetails = (jobId) => {
    try {
      var jobDetails = props.jobDetails;
      if (jobDetails != null) {
        setJobDetails(jobDetails);
        if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
          setJobStatus(jobDetails.jobStatus.key);
        }
      }                          
    } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
  
  };

  const handlePreviousButton = () => {
    props.parentCallback("fileUpload");
  };

  const nextFunction = () => {
    props.parentCallback("addnotes");
  };
  return (
    <div className="Container-box">
      <div className="row">
        <div className="col-sm-12">
          <div className="">
            <div className="addexperience right mb-2">
              <Card>
                <CardBody>
                  <SoftSkills key="softskill" jobDetails={jobDetails} />
                  <Separator  className="mt-5 mb-5"></Separator>
                  <Skills key="skill" jobDetails={jobDetails}></Skills>
                  <Separator  className="mt-5 mb-5"></Separator>
                  <LanguagesList key="language" jobDetails={jobDetails}/>
                  <Separator className="mt-5 mb-5"></Separator>
                  <Certification key="certigication" jobDetails={jobDetails}/>
                </CardBody>
              </Card>
            </div>

            <Row>
              <div>
                <Colxx>
                  <FormGroup>
                    <Button
                      color="primary"
                      size="sm"
                      outline
                      onClick={handlePreviousButton}
                    >
                      <MdOutlineArrowBackIosNew />
                    </Button>
                    <Button className="ml-2" color="primary" size="sm" outline>
                      <span
                        color="primary"
                        outline="true"
                        onClick={nextFunction}
                      >
                        {" "}
                        Next
                      </span>
                    </Button>
                  </FormGroup>
                </Colxx>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReqSkills;
